import { Components, darkScrollbar } from '@mui/material';
import { Theme } from '@mui/system';
import { fontFamily } from './components/typography';

export const buildMuiCssBaseline = (): Components<Omit<Theme, 'components'>>['MuiCssBaseline'] => ({
  styleOverrides: theme => {
    const scrollbarTrackColor = theme.palette.primary['20'] ? theme.palette.primary['20'] : theme.palette.common.white;
    const scrollbarThumbColor = theme.palette.primary['40'] ? theme.palette.primary['40'] : theme.palette.common.black;
    return {
      a: {
        textDecoration: 'none',
      },
      body: {
        background: theme.palette.primary['10'],
        color: theme.palette.primary.main,
        fontFamily: fontFamily,
        boxSizing: 'border-box',
      },
      html: {
        ...darkScrollbar({
          track: scrollbarTrackColor,
          thumb: scrollbarThumbColor,
          active: scrollbarThumbColor,
        }),

        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
          width: '8px',
          backgroundColor: scrollbarTrackColor,
        },
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
          borderRadius: '4px',
          backgroundColor: scrollbarThumbColor,
          minHeight: '55px',
        },
        scrollbarWidth: 'thin',
      },
    };
  },
});
